import React from 'react';

import classes from './Icon.css';

const cloudIcon = (props) => {
  return(
    <svg name="UploadImageBtn" onClick={props.clicked} version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" xmlnsXlink="http://www.w3.org/1999/xlink" className={classes.CloudIcon}>
      <path d="m22,0c-12.2,0-22,9.8-22,22s9.8,22 22,22 22-9.8 22-22-9.8-22-22-22zm-6.7,16.3l6-6c0.2-0.2 0.5-0.3 0.7-0.3s0.5,0.1 0.7,0.3l6,6c0.2,0.2 0.3,0.4 0.3,0.7s-0.1,0.5-0.3,0.7l-1.4,1.4c-0.2,0.2-0.4,0.3-0.7,0.3-0.3,0-0.5-0.1-0.7-0.3l-1-1c-0.3-0.3-0.9-0.1-0.9,0.4v6.6c0,0.6-0.4,1-1,1h-2c-0.6,0-1-0.4-1-1v-6.6c0-0.4-0.5-0.7-0.9-0.4l-1,1c-0.2,0.2-0.4,0.3-0.7,0.3-0.3,0-0.5-0.1-0.7-0.3l-1.4-1.4c-0.2-0.2-0.3-0.4-0.3-0.7s0.1-0.5 0.3-0.7zm19.7,16.7c0,0.6-0.4,1-1,1h-24c-0.6,0-1-0.4-1-1v-6c0-0.6 0.4-1 1-1h2c0.6,0 1,0.4 1,1v2.5c0,0.3 0.2,0.5 0.5,0.5h17c0.3,0 0.5-0.2 0.5-0.5v-2.5c0-0.6 0.4-1 1-1h2c0.6,0 1,0.4 1,1v6z"/>
    </svg>
  );
};

export default cloudIcon;



// WEBPACK FOOTER //
// ./src/components/Icon/CloudIcon.js